// L'API est injectée, donc on supprime l'import direct.
// import { apiService } from "../api";

export const createAuthService = (api) => ({
  async login(credentials) {
    try {
      const response = await api.post("/auth/login", credentials);
      return response.data;
    } catch (error) {
      console.error("Erreur de connexion:", error);
      throw error;
    }
  },

  async register(userData) {
    try {
      const response = await api.post("/auth/register", userData);
      return response.data;
    } catch (error) {
      console.error("Erreur d'inscription:", error);
      throw error;
    }
  },

  async logout() {
    try {
      // Note: Le logout peut ne pas nécessiter de corps de requête,
      // mais on garde la méthode post si le backend l'attend.
      const response = await api.post("/auth/logout");
      return response.data;
    } catch (error) {
      console.error("Erreur de déconnexion:", error);
      throw error;
    }
  },

  async refreshToken() {
    try {
      const response = await api.post("/auth/refresh-token");
      return response.data;
    } catch (error) {
      console.error("Erreur de rafraîchissement du token:", error);
      throw error;
    }
  },

  async verifyEmail(token) {
    try {
      const response = await api.get(`/auth/verify-email/${token}`);
      return response.data;
    } catch (error) {
      console.error("Erreur de vérification d'email:", error);
      throw error;
    }
  },

  async forgotPassword(email) {
    try {
      const response = await api.post("/auth/forgot-password", { email });
      return response.data;
    } catch (error) {
      console.error(
        "Erreur de demande de réinitialisation de mot de passe:",
        error,
      );
      throw error;
    }
  },

  async resetPassword(token, newPassword) {
    try {
      const response = await api.post("/auth/reset-password", {
        token,
        newPassword,
      });
      return response.data;
    } catch (error) {
      console.error("Erreur de réinitialisation de mot de passe:", error);
      throw error;
    }
  },

  async resendVerificationEmail(email) {
    try {
      const response = await api.post("/auth/resend-verification", { email });
      return response.data;
    } catch (error) {
      console.error("Erreur de renvoi d'email de vérification:", error);
      throw error;
    }
  },

  async getProfile() {
    try {
      const response = await api.get("/auth/me");
      return response.data;
    } catch (error) {
      console.error("Erreur de récupération du profil:", error);
      throw error;
    }
  },
});
